"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactIntl = require("react-intl");

var _reactResponsive = require("react-responsive");

var _lodash = require("lodash");

var _GridModal = _interopRequireDefault(require("./GridModal"));

var _ImageLayout = _interopRequireDefault(require("./ImageLayout"));

var _EmptyState = _interopRequireDefault(require("../../../../common/EmptyState"));

var _Elements = require("../../../../Elements");

var _constants = require("../../../../constants/constants");

var _Elements2 = require("./Elements");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/* eslint-disable react-hooks/exhaustive-deps */
var Grid = function Grid(_ref) {
  var folders = _ref.folders,
      title = _ref.title,
      photos = _ref.photos,
      description = _ref.description,
      onLoadMore = _ref.onLoadMore,
      maxLoadTimes = _ref.maxLoadTimes,
      currentLoadTimes = _ref.currentLoadTimes,
      layoutWidth = _ref.layoutWidth,
      setLayoutWidth = _ref.setLayoutWidth,
      colour = _ref.colour,
      webpSupported = _ref.webpSupported;
  var isDesktopLarge = (0, _reactResponsive.useMediaQuery)({
    query: '(min-width: 1900px)'
  });
  var isDesktopMedium = (0, _reactResponsive.useMediaQuery)({
    query: '(min-width: 1440px)'
  });
  var isDesktopSmall = (0, _reactResponsive.useMediaQuery)({
    query: '(min-width: 1152px)'
  });
  var isTabletLandScape = (0, _reactResponsive.useMediaQuery)({
    query: '(min-width: 1024px)'
  });
  var isTabletPortrait = (0, _reactResponsive.useMediaQuery)({
    query: '(min-width: 768px)'
  });
  var isMobileLandScape = (0, _reactResponsive.useMediaQuery)({
    query: '(min-width: 667px)'
  });
  var isMobilePortrait = (0, _reactResponsive.useMediaQuery)({
    query: '(min-width: 375px)'
  });
  var showRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(0),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      imgClickTimes = _useState2[0],
      setImageClickTimes = _useState2[1];

  var _useState3 = (0, _react.useState)('0'),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      imgClickId = _useState4[0],
      setImageClickId = _useState4[1];

  var _useState5 = (0, _react.useState)('0'),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      imgClickFolderId = _useState6[0],
      setImageClickFolderId = _useState6[1];

  var _useState7 = (0, _react.useState)(window.innerWidth),
      _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
      innerWidth = _useState8[0],
      setInnerWidth = _useState8[1];

  var handleInnerWidth = (0, _lodash.debounce)(function () {
    setInnerWidth(window.innerWidth);
  }, 200);
  (0, _react.useEffect)(function () {
    window.addEventListener('resize', handleInnerWidth);
    return function () {
      return window.removeEventListener('resize', handleInnerWidth);
    };
  });
  var layoutConfig = (0, _react.useMemo)(function () {
    if (isDesktopLarge) {
      return {
        columns: 4,
        columnWidth: 427,
        gutter: 32
      };
    }

    if (isDesktopMedium) {
      return {
        columns: 3,
        columnWidth: 427,
        gutter: 32
      };
    }

    if (isDesktopSmall) {
      return {
        columns: 3,
        columnWidth: 331,
        gutter: 32
      };
    }

    if (isTabletLandScape) {
      return {
        columns: 2,
        columnWidth: 480,
        gutter: 16
      };
    }

    if (isTabletPortrait) {
      return {
        columns: 2,
        columnWidth: 352,
        gutter: 16
      };
    }

    if (isMobileLandScape) {
      return {
        columns: 2,
        columnWidth: 330,
        gutter: 8
      };
    }

    if (isMobilePortrait) {
      return {
        columns: 1,
        columnWidth: innerWidth,
        gutter: 8
      };
    }

    return {
      columns: 1,
      columnWidth: innerWidth,
      gutter: 8
    };
  }, [isDesktopLarge, isDesktopMedium, isDesktopSmall, isMobileLandScape, isMobilePortrait, isTabletLandScape, isTabletPortrait, innerWidth]);

  var loadMore = function loadMore() {
    return onLoadMore();
  };

  return /*#__PURE__*/_react["default"].createElement(_Elements2.GridBox, {
    flex: true,
    align: "center",
    justify: "center",
    column: true
  }, description && /*#__PURE__*/_react["default"].createElement(_Elements2.DescriptionBox, null, /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioParagraph, {
    portfolioForeground1: true,
    mb: "md",
    large: true,
    center: true
  }, description)), photos.length > 0 ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_ImageLayout["default"], (0, _extends2["default"])({}, layoutConfig, {
    webpSupported: webpSupported,
    photos: photos,
    layoutWidth: layoutWidth,
    setLayoutWidth: setLayoutWidth,
    onImgClick: function onImgClick(index, photo) {
      var _showRef$current;

      setImageClickTimes(function (prev) {
        return prev + 1;
      });
      setImageClickId(photo === null || photo === void 0 ? void 0 : photo.id);
      setImageClickFolderId(photo === null || photo === void 0 ? void 0 : photo.folderId); // eslint-disable-next-line no-unused-expressions

      showRef === null || showRef === void 0 ? void 0 : (_showRef$current = showRef.current) === null || _showRef$current === void 0 ? void 0 : _showRef$current.showModal();
    }
  })), currentLoadTimes < maxLoadTimes && /*#__PURE__*/_react["default"].createElement(_Elements2.ShowMoreButton, {
    onClick: loadMore,
    colour: _constants.PORTFOLIO_THEME_COLOR[colour]
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.moodie.cta.show_more"
  }))) : /*#__PURE__*/_react["default"].createElement(_EmptyState["default"], {
    site: title
  }), /*#__PURE__*/_react["default"].createElement(_GridModal["default"], {
    folders: folders,
    ref: showRef,
    imgClickId: imgClickId,
    imgClickFolderId: imgClickFolderId,
    colour: colour,
    imgClickTimes: imgClickTimes,
    webpSupported: webpSupported
  }));
};

Grid.defaultProps = {
  title: '',
  description: '',
  onLoadMore: function onLoadMore() {},
  colour: '',
  webpSupported: false,
  layoutWidth: 0,
  getLayoutWidth: function getLayoutWidth() {}
};
Grid.propTypes = {
  folders: _propTypes["default"].arrayOf(_propTypes["default"].shape()).isRequired,
  title: _propTypes["default"].string,
  photos: _propTypes["default"].arrayOf(_propTypes["default"].shape()).isRequired,
  description: _propTypes["default"].string,
  onLoadMore: _propTypes["default"].func,
  maxLoadTimes: _propTypes["default"].number.isRequired,
  currentLoadTimes: _propTypes["default"].number.isRequired,
  colour: _propTypes["default"].string,
  webpSupported: _propTypes["default"].bool,
  layoutWidth: _propTypes["default"].number,
  getLayoutWidth: _propTypes["default"].func
};
var _default = Grid;
exports["default"] = _default;